import { clsx } from '@appvantageasia/core-utils';
import {
    ScrollAreaScrollbar,
    ScrollAreaThumb,
    Root,
    Viewport,
    Corner,
    type ScrollAreaProps,
    type ScrollAreaScrollbarProps,
} from '@radix-ui/react-scroll-area';

const ScrollBar = ({ className, orientation = 'vertical', ...props }: ScrollAreaScrollbarProps) => (
    <ScrollAreaScrollbar
        orientation={orientation}
        className={clsx(
            'flex touch-none transition-colors select-none',
            orientation === 'vertical' && 'h-full w-2.5 border-l border-l-transparent p-px',
            orientation === 'horizontal' && 'h-2.5 border-t border-t-transparent p-px',
            className
        )}
        {...props}
    >
        <ScrollAreaThumb className="bg-border relative flex-1 rounded-full" />
    </ScrollAreaScrollbar>
);

const ScrollArea = ({ className, children, ...props }: ScrollAreaProps) => (
    <Root className={clsx('relative overflow-hidden', className)} {...props}>
        <Viewport className="h-full w-full rounded-[inherit]">{children}</Viewport>
        <ScrollBar />
        <Corner />
    </Root>
);

export default ScrollArea;
